import Model, { attr } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import type StringTransform from 'teacher-ui-client/transforms/string'

/**
 * @summary a Rollover is 'owned' by a teacher in the BE, this class was
 * created so that the Ember data store only contains teachers suitable for
 * display in the manage teachers page, not teachers that have been deleted
 * but are still associated with a rollover.
 *
 */
export default class RolloverOwner extends Model {
  @attr<StringTransform>('string') declare firstName: string

  @attr<StringTransform>('string') declare lastName: string

  get fullName() {
    return `${this.firstName} ${this.lastName}`
  }

  [Type] = 'rollover-owner' as const
}
